import ErrorModal from "components/AppErrorModal";
import "./App.css";
import "./App.scss";
import AppRoutes from "routes/router";
import { useGlobalStateStore } from "stores/useGlobalState";
import { useMemo } from "react";
import AppSpinner from "components/AppSpinner";

function App() {
  const { globalState, setErrorState } = useGlobalStateStore();
  const hasError = useMemo(() => !!globalState.error, [globalState.error]);
  const isLoading = useMemo(() => globalState.loading, [globalState.loading]);
  return (
    <>
      <AppSpinner loading={isLoading!} />
      <ErrorModal
        title={globalState.error}
        show={hasError}
        centered
        onClose={() => setErrorState(null)}
      />
      <AppRoutes />;
    </>
  );
}

export default App;
